module.exports = __webpack_public_path__ + "img/email-monochrome.74b3163e.svg";